import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class WikiService {
  
  private wikiCache = new Map<string, string>();

  constructor(private http: HttpClient) { }

  getWikiText(name: string, fromCache = true): Observable<string> {
    if (fromCache && this.wikiCache.has(name)) { // read from cache
      const description = this.wikiCache.get(name);
      return of(description);
    } else { // live request      
      return this.http.get(`/search/wiki?name=${name}`)
        .pipe(
          // get description
          map((response: any) => response.description),
          // special case: catch + cache 404
          catchError((err: HttpErrorResponse) => err.status === 404 ? of('') : throwError(err)),
          // add cache entry
          tap((description) => this.wikiCache.set(name, description))
        );
    }
  } 
}
